import TransactionCodeDeleteModal from "./TransactionCodeDeleteModal";

export default TransactionCodeDeleteModal;
